import { CheckoutContainer } from '@components'
import MethodButton from '@components/SelectMethod/MethodButton'
import { PaymentMethods } from 'mmfintech-checkout-commons'
import { useState } from 'react'

import '@components/SelectMethod/selectMethod.scss'
import '@views/CheckoutPayment/checkout.scss'

const TestMethods = () => {
  const [selected, setSelected] = useState<string>(null)

  return (
    <CheckoutContainer>
      <div className='checkout-content'>
        <h2>Testing method names and logos</h2>

        <div className='payment-container'>
          <div className='select-method-wrapper'>
            <div className='select-content use-grid'>
              {Object.keys(PaymentMethods)
                .sort()
                .map(name => {
                  return (
                    <MethodButton
                      key={name}
                      name={name}
                      selected={selected === name}
                      setSelected={name => {
                        setSelected(name)
                        console.log('selected:', name)
                      }}
                    />
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </CheckoutContainer>
  )
}

export default TestMethods
